import type { ReactNode } from 'react';

import { Button } from '#/components/Button/Button';
import { Icon } from '#/components/Icon/Icon';
import { Text } from '#/components/Text/Text';

import {
  BreadcrumbsAllLinksHolder,
  BreadcrumbsBackLinkOnlyHolder,
  LinkContainer,
  Separator,
  StyledRouterLink,
} from './Breadcrumbs.styled';

export type BreadcrumbLink = {
  qaId?: string;
  title: ReactNode;
  to?: string;
  state?: Record<string, unknown>;
};

type Props = {
  qaId?: string;
  links: BreadcrumbLink[];
};

export function Breadcrumbs({ links, qaId }: Props) {
  const backLinkHref = links.at(-2)?.to || null;

  return (
    <Text styleAs="bodySmall" qaId={qaId ?? 'breadcrumbs'}>
      {backLinkHref && (
        <BreadcrumbsBackLinkOnlyHolder>
          <Button
            variant="link"
            type="link"
            href={backLinkHref}
            icon={{ name: 'chevron-left' }}
            noPadding
          >
            Back
          </Button>
        </BreadcrumbsBackLinkOnlyHolder>
      )}

      <BreadcrumbsAllLinksHolder $noBackLink={!backLinkHref}>
        {links.map(({ title, to, state, qaId: linkQaId }, index) => (
          <LinkContainer
            key={to ?? (typeof title === 'string' ? title : `crumb-${index}`)}
          >
            {index > 0 && (
              <Separator>
                <Icon name="chevron-left" size={11} />
              </Separator>
            )}
            <StyledRouterLink
              data={
                to ? { type: 'link-with-state', to, state } : { type: 'inert' }
              }
              qaId={linkQaId}
            >
              {title}
            </StyledRouterLink>
          </LinkContainer>
        ))}
      </BreadcrumbsAllLinksHolder>
    </Text>
  );
}
